import matchHeight from "jquery-match-height";
// TODO: Work on a responsive way to handle heights.
function handleLeftColumn() {
  const mid1Height = $(".item-mid-1").outerHeight(true);
  const mid3Height = $(".item-mid-3").outerHeight(true);

  const midTotal = mid1Height + mid3Height;
  $(".left-grid-item").height(midTotal);

  const right1Height = $(".item-right-1").outerHeight();
  $(".item-left-1").height(right1Height);
}
export default {
  init() {  
    $("#benefits-with-icons .row-assets > div").matchHeight({ byRow: true });
    handleLeftColumn();

    $(".cards .slick-track .card").matchHeight({ byRow: true });

    if ($(".block-home-solutions").length) {
      setTimeout(() => {
        $(".block-home-solutions .row--solutions .solution").matchHeight({
          byRow: true,
        });
      }, 500);
    }
  },
};
